export default {
  draw: 33,
  columns: [
    {
      data: 0,
      name: '',
      searchable: true,
      orderable: true,
      search: {
        value: '',
        regex: false,
      },
    },
    {
      data: 1,
      name: '',
      searchable: true,
      orderable: true,
      search: {
        value: '',
        regex: false,
      },
    },
    {
      data: 2,
      name: '',
      searchable: true,
      orderable: true,
      search: {
        value: '',
        regex: false,
      },
    },
    {
      data: 3,
      name: '',
      searchable: true,
      orderable: true,
      search: {
        value: '',
        regex: false,
      },
    },
    {
      data: 4,
      name: '',
      searchable: true,
      orderable: true,
      search: {
        value: '',
        regex: false,
      },
    },
    {
      data: 5,
      name: '',
      searchable: true,
      orderable: true,
      search: {
        value: '',
        regex: false,
      },
    },
  ],
  order: [
    {
      column: 1,
      dir: 'desc',
    },
  ],
  start: 0,
  length: 10,
  search: {
    value: '',
    regex: false,
  },
  call: 'getBusinessCallHistory',
  apiKey: 'd8810712-df40-11e4-9ccc-22000ac88c3a',
  startdate: '2018-08-01',
  enddate: '2018-09-20',
  timezone: 'America/Los_Angeles',
  crmid: 16,
};
